module.exports = require("react-resize-observer");